import React from 'react';
import './PartnerBenefits.css';

const PartnerBenefits = () => {
  const benefits = [
    {
      icon: '💼',
      title: 'Multiple Revenue Streams',
      description: 'Earn through voice rooms, virtual gifts, sponsored events, and premium content'
    },
    {
      icon: '📈',
      title: 'Growth Support',
      description: 'Dedicated partner managers to help optimize your content strategy and earnings'
    },
    {
      icon: '✓',
      title: 'Verified Status',
      description: 'Stand out with a verified partner badge and priority visibility in discovery'
    },
    {
      icon: '🎁',
      title: 'Rewards System',
      description: 'Earn additional rewards based on your lifetime earnings and total time spent on platform'
    },
    {
      icon: '👥',
      title: 'Exclusive Community',
      description: 'Connect with fellow partners for collaborations and knowledge sharing'
    },
    {
      icon: '📅',
      title: '7-Day Payouts',
      description: 'Reliable transfers every 7 days directly to your bank account or UPI'
    }
  ];

  return (
    <section className="partner-benefits">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Partner Benefits That Drive Success</h2>
          <p className="section-description">
            Everything you need to build, monetize, and grow your voice-based community.
          </p>
        </div>
        <div className="partner-benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="partner-benefit-card">
              <div className="partner-benefit-icon">
                <span>{benefit.icon}</span>
              </div>
              <h3 className="partner-benefit-title">{benefit.title}</h3>
              <p className="partner-benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerBenefits;

